import RequestYourInterestForm from "./RequestYourInterest";

export const requestYourInterest = {
    init: () => {
        const form = document.querySelector(".membership__form");
        if (form) {            
          new RequestYourInterestForm(form)
        }
      },
}

export default requestYourInterest;